import { useTitle as l } from "@vueuse/core";
import { ref as o, readonly as r } from "vue";
const e = o(""), a = o("");
l(e);
const n = r(e), p = r(a);
function s({
  documentValue: t = "",
  topFrameValue: i = void 0
}) {
  return e.value = t, a.value = i ?? t, { documentValue: n, topFrameValue: p };
}
export {
  n as pageTitle,
  s as setPageTitle,
  p as topFrameTitle
};
